import { render } from "./CheckPersonalizations.vue?vue&type=template&id=05f20324&scoped=true"
import script from "./CheckPersonalizations.vue?vue&type=script&lang=js"
export * from "./CheckPersonalizations.vue?vue&type=script&lang=js"

import "./CheckPersonalizations.vue?vue&type=style&index=0&id=05f20324&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f20324"]])

export default __exports__